/** Financeiro → Contas a pagar. Wrapper fino de ContasView (kind='pagar'). */
import ContasView from './ContasView.jsx'

export default function ContasPagar() {
  return <ContasView kind="pagar" />
}
